module.exports = __webpack_public_path__ + "static/media/resume.96f98715.wav";